<ion-header>
  <ion-toolbar>
    <ion-title>{{texts.badge.autogehenMultiorder | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col class="visum-grid-item">
        <ion-label>{{texts.badge.autogehenTime | translate}}</ion-label>
        <mat-form-field appearance="outline">
          <input [formControl]="timeInput" matInput type="time" />
        </mat-form-field>
      </ion-col>
    </ion-row>
    <ion-row class="visum-grid-item">
      <ion-text>{{texts.badge.autoghenExplained | translate}}</ion-text>
    </ion-row>
    <ion-row>
      <ion-col class="visum-grid-item">
        <ion-button (click)="setVisum()">
          {{texts.badge.setAutogehen | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-tab-button (click)="emitCancelEvent()" slot="end">
      <ion-icon name="arrow-back"></ion-icon>
      <ion-label>{{ texts.general.cancel | translate}}</ion-label>
    </ion-tab-button>
  </ion-toolbar>
</ion-footer>
